import { gettext } from '@adjust/dashboard-core/lib/utils/localization';

const invoiceStatusMap = {
  open: gettext('invoice.status.open'),
  pending: gettext('invoice.status.pending'),
  paid: gettext('invoice.status.paid'),
  credited: gettext('invoice.status.credited'),
  rejected: gettext('invoice.status.rejected'),
  cancelled: gettext('invoice.status.cancelled'),
  // eslint-disable-next-line @typescript-eslint/naming-convention
  partially_paid: gettext('invoice.status.partially-paid'),
  // eslint-disable-next-line @typescript-eslint/naming-convention
  partially_credited: gettext('invoice.status.partially-credited'),
  // eslint-disable-next-line @typescript-eslint/naming-convention
  on_hold: gettext('invoice.status.on-hold'),
};

const creditNoteSpecificStatusMap = {
  open: gettext('invoice.status.processing'),
  paid: gettext('invoice.status.refunded'),
};

export const getLocalizedStatus = (status: string, isCreditNote: boolean): string => {
  const translationKey = (isCreditNote && creditNoteSpecificStatusMap[status]) || invoiceStatusMap[status];

  return t(translationKey);
};
